module.exports = __webpack_public_path__ + "img/01d.cf2890b0.gif";